import {stopPreviewVideo} from "./stopPreviewVideo";

export function initPageVideo() {
    const   loader = document.querySelector('.preloader'),
        previewVideo = document.getElementById('video-preview');

    initPreloader('/videos/animation-compressed.mp4');

    function initPreloader(link) {
        let initial = 251.3274;

        let xhr = new XMLHttpRequest();

        xhr.open('GET', link);

        xhr.onprogress = function (event) {
            let val = Math.round((event.loaded * 100) / event.total);

            animationPreloader(val, initial);
        }

        xhr.onload = function () {
            loader.classList.add('none');
            previewVideo.classList.remove('opacity-0');

            previewVideo.play();

            previewVideo.addEventListener("ended", () => {
                stopPreviewVideo(500);
                previewVideo.classList.add('ended');
            });
        }

        xhr.send();
    }

    function animationPreloader(val, initial) {
        loader.querySelector('.preloader__count').textContent = `${val}`;

        if (+val === 100) {
            loader.querySelector('.progress-bar').style.strokeDashoffset = 0;
        } else {
            loader.querySelector('.progress-bar').style.strokeDashoffset = initial - ((initial * val) / 100);
        }
    }
}
